import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CardListBreakpointsService {
  constructor() {}

  private breakpoints = [
    { maxWidth: 2015, viewWidth: 14 },
    { maxWidth: 1600, viewWidth: 16 },
    { maxWidth: 1360, viewWidth: 22 },
    { maxWidth: 900, viewWidth: 28 }
  ];

  getItemsPerRow(windowWidth: number = window.innerWidth): number {
    let itemsPerRow = Math.floor(78 / 12);
    for (const breakpoint of this.breakpoints) {
      if (windowWidth <= breakpoint.maxWidth) {
        itemsPerRow = Math.floor(78 / breakpoint.viewWidth);
      }
    }
    return itemsPerRow;
  }

  getEmptyVideoCards(videosPageLength: number) {
    const emptyVideoCards: null[] = [];

    const itemsPerRow = this.getItemsPerRow();

    const remainder = videosPageLength % itemsPerRow;

    if (remainder === 0) return emptyVideoCards;

    const blanksToAdd = itemsPerRow - remainder;
    for (let i = 0; i < blanksToAdd; i++) {
      emptyVideoCards.push(null);
    }

    return emptyVideoCards;
  }
}
